import { gql } from "@apollo/client";

export const SEND_EMAIL_FOR_FORGOT_PASSWORD = gql`
  query SendEmailForForgotPassword($email: String!){
    sendEmailForForgotPassword(sendEmailForForgotPasswordInput: { email: $email })
  }
`;

export const GET_FAVOURITE_PROPERTIES = gql`
  query GetFavouriteProperties {
    getFavoriteProperties{
      message
      statusCode
      success
      properties {
        id
        address
        brochure
        description
        images
        minimumInvestment
        totalShares
        documents {
          isConfidential
          file
          name
        }
        contactInformation {
          email
          firstName
          lastName
          phoneNumber
        }
        images
        investmentHighlights {
          description
          title
        }
        location
        mapLocation
        marketplaceId
        name
        performanceMetrics {
          closingDate
          netOperatingIncome
          pricePerToken
          squareMeter
          targetEquity
          targetPeriod
          targetedAverageCashYield
          targetedEquityMultiple
          targetedInvestorIRR
          units
          yearBuilt
        }
        propertyClass
        propertyStatus
        propertyType
        rejectionReason
        riskLevel
        tickerSymbol
        sponsors {
          description
          image
          name
        }
      }
    }
  }
`;

export const GET_FAVORITE_PROPERTIES_IDS = gql`
  query GetFAvoriteProperties{
    getFavoriteProperties{
      message
      statusCode
      success
      properties {
        id
      }
    }
  }
`;

export const GET_INTERESTED_PROPERTIES = gql`
  query GetInterestedProperties {
    getInterestedProperties {
      message
      statusCode
      success
      properties {
        id
        address
        brochure
        description
        images
        minimumInvestment
        totalShares
        documents {
          isConfidential
          file
          name
        }
        contactInformation {
          email
          firstName
          lastName
          phoneNumber
        }
        images
        investmentHighlights {
          description
          title
        }
        location
        mapLocation
        marketplaceId
        name
        performanceMetrics {
          closingDate
          netOperatingIncome
          pricePerToken
          squareMeter
          targetEquity
          targetPeriod
          targetedAverageCashYield
          targetedEquityMultiple
          targetedInvestorIRR
          units
          yearBuilt
        }
        propertyClass
        propertyStatus
        propertyType
        rejectionReason
        riskLevel
        tickerSymbol
        sponsors {
          description
          image
          name
        }
      }
    }
  }
`

export const USER_LOGIN = gql`
  query userLogin($email: String!,$password: String!){
    login(loginInput: { email: $email, password:$password}){
      statusCode
      message
      accessToken
    }
  }
`



export const GET_USER_DATA = gql`
  query GetUserData {
    getUserData {
      userId
      firstName
      lastName
      email
      phoneNumber
      profileImage
    }
  }
`;

export const GET_ALL_PROPERTIES = gql`
  query GetAllProperties {
    getAllSubmitProperty {
      address
      brochure
      description
      images
      minimumInvestment
      totalShares
      documents {
        isConfidential
        file
        name
      }
      id
      contactInformation {
        email
        firstName
        lastName
        phoneNumber
      }
      images
      investmentHighlights {
        description
        title
      }
      location
      mapLocation
      marketplaceId
      name
      performanceMetrics {
        closingDate
        netOperatingIncome
        pricePerToken
        squareMeter
        targetEquity
        targetPeriod
        targetedAverageCashYield
        targetedEquityMultiple
        targetedInvestorIRR
        units
        yearBuilt
      }
      propertyClass
      propertyStatus
      propertyType
      rejectionReason
      riskLevel
      tickerSymbol
      sponsors {
        description
        image
        name
      }
    }
  }
`;
export const SEARCH_PROPERTIES_MARKETPLACE = gql`
  query SearchPropertiesByMarketplace($location:String!) {
    searchPropertiesByMarketplace(marketplaceLocationInput: {location:$location}) {
      id
      address
      brochure
      contactInformation{
        email
        firstName
        lastName
        phoneNumber
      }
      description
      minimumInvestment
      totalShares
      documents{
        file
        isConfidential
        name
      }
      id
      images
      investmentHighlights{
        description
        title
      }
      mapLocation
      marketplaceId
      minimumInvestment
      name
      performanceMetrics{
        closingDate
        netOperatingIncome
        pricePerToken
        squareMeter
        targetEquity
        targetPeriod
        targetedAverageCashYield
        targetedEquityMultiple
        targetedInvestorIRR
        units
        yearBuilt
      }
      propertyClass
      propertyType
      rejectionReason
      riskLevel
      sponsors{
        description
        image
        name
      }
      tickerSymbol

    }
  }
`;
export const GET_PROPERTIES_BY_FILTER = gql`
  query GetPropertiesByFilter($propertyClass:String, $propertyType:String,$riskLevel:String,$status:String) {
    getPropertiesByFilter(getPropertiesByFilterInput: {propertyClass:$propertyClass, propertyType:$propertyType, riskLevel:$riskLevel, status:$status}) {
      id
      address
      brochure
      minimumInvestment
      totalShares
      contactInformation{
        email
        firstName
        lastName
        phoneNumber
      }
      description
      documents{
        file
        isConfidential
        name
      }
      id
      images
      investmentHighlights{
        description
        title
      }
      mapLocation
      marketplaceId
      minimumInvestment
      name
      performanceMetrics{
        closingDate
        netOperatingIncome
        pricePerToken
        squareMeter
        targetEquity
        targetPeriod
        targetedAverageCashYield
        targetedEquityMultiple
        targetedInvestorIRR
        units
        yearBuilt
      }
      propertyClass
      propertyType
      rejectionReason
      riskLevel
      sponsors{
        description
        image
        name
      }
      tickerSymbol

    }
  }
`;
export const GET_PROPERTY_BY_ID = gql`
  query getPropertyById($propertyId:String!) {
    getPropertyById(propertyId:$propertyId) {
      minimumInvestment
      totalShares
      address
      brochure
      contactInformation{
        email
        firstName
        lastName
        phoneNumber
      }
      description
      documents{
        file
        isConfidential
        name
      }
      id
      images
      investmentHighlights{
        description
        title
      }
      mapLocation
      marketplaceId
      minimumInvestment
      name
      performanceMetrics{
        closingDate
        netOperatingIncome
        pricePerToken
        squareMeter
        targetEquity
        targetPeriod
        targetedAverageCashYield
        targetedEquityMultiple
        targetedInvestorIRR
        units
        yearBuilt
      }
      propertyClass
      propertyType
      rejectionReason
      riskLevel
      sponsors{
        description
        image
        name
      }
      tickerSymbol

    }
  }
`;